import { Action, ActionsList } from 'components';
import { TranslationPath, useTranslation } from 'libs/i18n';
import { Icon } from 'libs/ui/Icon';
import { SvgProps } from 'libs/ui/Icon/icons/types';

import { ActionType } from '../types';

interface Props {
  actions: {
    type: ActionType;
  }[];
  onClickAction: (value: ActionType) => void;
}

const ACTION_MAP: Record<
  ActionType,
  {
    label: TranslationPath;
    Icon: React.FC<SvgProps>;
    color?: SvgProps['color'];
  }
> = {
  [ActionType.showVersionHistory]: {
    label: 'client.client.versions.showVersionHistoryLabel',
    Icon: Icon.Time,
  },
  [ActionType.edit]: {
    label: 'common.edit',
    Icon: Icon.Edit,
  },
  [ActionType.changeOnboardingStatus]: {
    label: 'client.changeOnboardingStatusLabel',
    Icon: Icon.Repeat,
  },
  [ActionType.changeAccountStatus]: {
    label: 'client.changeAccountStatusLabel',
    Icon: Icon.Repeat,
  },
  [ActionType.delete]: {
    label: 'common.delete',
    Icon: Icon.Bucket,
    color: 'red',
  },
  [ActionType.archive]: {
    label: 'common.archive',
    Icon: Icon.TimeSleep,
  },
  [ActionType.dearchive]: {
    label: 'common.dearchive',
    Icon: Icon.RotateRightCheck,
  },
  [ActionType.revokeOtpVerification]: {
    label: 'common.revokeOtpVerification',
    Icon: Icon.Lock,
  },
  [ActionType.sendInvitationToAccount]: {
    label: 'client.sendInvitationToAccountLabel',
    Icon: Icon.Messages,
  },
  [ActionType.linkToBright]: {
    label: 'client.linkToBrightLabel',
    Icon: Icon.CloudDownload,
  },
  [ActionType.downloadClientQuestionnaire]: {
    label: 'common.exportPDF',
    Icon: Icon.Download,
  },
};

export const Actions = ({ actions, onClickAction }: Props) => {
  const { t } = useTranslation();
  return (
    <ActionsList>
      {actions.map((action) => {
        const { Icon, label, color } = ACTION_MAP[action.type];
        return (
          <Action
            key={action.type}
            tooltip={t(label)}
            onClick={() => onClickAction(action.type)}
          >
            <Icon color={color} size={16} />
          </Action>
        );
      })}
    </ActionsList>
  );
};
